import axios from '@/axiosInterceptor';

const state = () => ({
  all: {
    data: [],
    isLoading: false,
    hasLoaded: false,
    controller: null,
    pagination: {
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
    },
    query: {},
  },
  alert: {
    data: {},
    isLoading: false,
    hasLoaded: false,
  },
});

const mutations = {
  setAlertsData(state, { type, value }) {
    state[type].data = value;
  },
  setAlertsPagination(state, { type, value }) {
    state[type].pagination = value;
  },
  setAlertsQuery(state, { type, value }) {
    state[type].query = value;
  },
  setAlertsLoading(state, { type, value }) {
    state[type].isLoading = value;
  },
  setAlertsHasLoaded(state, { type, value }) {
    state[type].hasLoaded = value;
  },
  setAlertsController(state, { type, value }) {
    state[type].controller = value;
  },
};

const actions = {
  async getAlertDetails({ commit }, id) {
    try {
      commit('setAlertsLoading', { type: 'alert', value: true });
      commit('setAlertsHasLoaded', { type: 'alert', value: false });
      const url = `${process.env.API_MONITOR}/api/v1/tickets/${id}/insurance_show`;
      //   for testing only
      //   const url = 'http://localhost:4000/alert';
      let res = await axios.get(url);
      commit('setAlertsLoading', { type: 'alert', value: false });
      commit('setAlertsHasLoaded', { type: 'alert', value: true });
      if (res?.data) {
        commit('setAlertsData', { type: 'alert', value: res.data });
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
      commit('setAlertsLoading', { type: 'alert', value: false });
      commit('setAlertsHasLoaded', { type: 'alert', value: true });
      commit('setAlertsData', { type: 'alert', value: {} });
      return e;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
